"use strict";

export const PRO_CLIENTS = [
	"com.simulationcurriculum.SkySafari6Pro",
	"com.simulationcurriculum.SkySafari7Pro",
	"com.simulationcurriculum.SkySafari7Pro.iOS",
	"com.simulationcurriculum.SkySafari8Pro",
	"com.simulationcurriculum.SkySafari8Pro.iOS",
	"com.simulationcurriculum.SkySafari6MacPro",
	"com.simulationcurriculum.SkySafari7MacPro",
	"com.simulationcurriculum.SkySafari8MacPro",
	"com.simulationcurriculum.skysafari6pro.android.",
	"com.simulationcurriculum.skysafari7pro.android",
	"com.simulationcurriculum.skysafari8pro.android",
	"com.simulationcurriculum.skysafari6pro.android",
	"com.simulationcurriculum.starrynight.proplus.8.osx",
	"com.simulationcurriculum.starrynight.proplus.8.win32",
	"com.simulationcurriculum.starrynight.pro.8.osx",
	"com.simulationcurriculum.starrynight.pro.8.win32",
];

export const PLUS_CLIENTS = [
	"com.simulationcurriculum.SkySafari6Plus",
	"com.simulationcurriculum.SkySafari7Plus",
	"com.simulationcurriculum.SkySafari7Plus.iOS",
	"com.simulationcurriculum.SkySafari8Plus",
	"com.simulationcurriculum.SkySafari8Plus.iOS",
	"com.simulationcurriculum.SkySafari6MacPlus",
	"com.simulationcurriculum.SkySafari7MacPlus",
	"com.simulationcurriculum.SkySafari8MacPlus",
	"com.simulationcurriculum.skysafari6plus.android.",
	"com.simulationcurriculum.skysafari7plus.android",
	"com.simulationcurriculum.skysafari8plus.android",
	"com.simulationcurriculum.skysafari6plus.android",
	"com.meade.StellaAccess",
	"com.meade.stellaaccess",
	"com.simulationcurriculum.starrynight.enthusiast.8.osx",
	"com.simulationcurriculum.starrynight.enthusiast.8.win32",
];

export const BASIC_CLIENTS = [
	"com.simulationcurriculum.SkySafari6",
	"com.simulationcurriculum.SkySafari7",
	"com.simulationcurriculum.skysafari5",
	"com.celestron.skyportal",
	"com.simulationcurriculum.starrynight.csap.8.osx",
	"com.simulationcurriculum.starrynight.csap.8.win32",
];
